import WsProvider from './provider/WSProvider'


var base64 = require('base64_js');
var serviceName = "dashboard";
var dashboardService = {
    countDash() {
        var userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
        var param = {
            data: {
                yonetimId: userDataSidas["yonetimId"],
                userToken: userDataSidas["token"],
                firmaKodu: userDataSidas["firmaKodu"],
                methodName: "countDash"

            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

}

export default dashboardService

